(ns minorodata.components.data-views.core
  (:require [minorodata.app.handlers :refer [dispatch dispatch-sync]]
            [minorodata.components.data-views.panel :refer [panel]]
            [minorodata.components.data-views.sidebar :refer [sidebar]]
            [minorodata.components.sql-console-modal.core :refer [toggle-console-modal]]
            [minorodata.data-views.model :refer [->data-views-page]]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            ["allotment" :refer [Allotment]]
            [ui.button :refer [button]]
            [ui.page :refer [page-content page-header page-root page-title]]))

(defn create-in-sql-console-button []
  (let [on-click toggle-console-modal]
    [button {:disabled (not @(re-posh/subscribe [:users.subs/has-permissions? [:data-views/write :sql-browser/read]]))
             :on-click on-click
             :data-cy  "create-data-view"
             :class    "-my-2"}
     [:div {:class "text-center"}
      "Create"
      [:small {:class "block text-xs leading-3 text-kleene-dark-01/60"}
       "in the SQL console"]]]))

(defn data-views-page []
  [page-root {:class " min-h-0 h-screen grid grid-rows-[auto_1fr] overflow-hidden"}
   [page-header {:variant       :border
                 :content-props {:class "flex justify-between"}}
    [page-title "Share data"]
    [create-in-sql-console-button]]

   [page-content {:variant :border}

    [:> Allotment {:min-size 200}
     [:> Allotment.Pane {:min-size       300
                         :max-size       js/Infinity
                         :preferred-size 300}
      [sidebar]]
     [panel]]]])

(defn main []
  (reagent/create-class
   {:display-name
    "data-views-page"

    :constructor
    (fn []
      (let [initial-state (->data-views-page {:sidebar-tab   "all"
                                              :editor-height "250px"})]
        (dispatch-sync [:data-views-page/add initial-state])))

    :render
    (fn []
      [data-views-page])}))
